import React from "react";

export const MONTH_NAMES = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

export const formatRupiah = (val: number) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(val);
};

export const formatNumber = (val: number) => {
  return new Intl.NumberFormat("id-ID").format(val);
};

export const formatPercent = (val: number) => {
  if (isNaN(val) || !isFinite(val)) return "0%";
  return `${val.toFixed(1)}%`;
};

export const getProgressColor = (percent: number) => {
  if (percent >= 90) return "#52c41a"; // Emerald
  if (percent >= 70) return "#faad14"; // Warning Yellow
  return "#ff4d4f"; // Error Red
};

export const glassCardStyle: React.CSSProperties = {
  background: "rgba(255, 255, 255, 0.45)",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  border: "1px solid rgba(255, 255, 255, 0.25)",
  borderRadius: "12px",
  boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.04)",
  padding: "20px",
  height: "100%",
  transition: "all 0.3s ease",
};

export const glassTableContainerStyle: React.CSSProperties = {
  background: "rgba(255, 255, 255, 0.35)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "12px",
  padding: "16px",
  boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.02)",
};
